module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-no"
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("This book is dedicated to my mum, Hazel Gibson")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I love her heaps and am blessed to have had her love and support in all that I have done in life, wherever I am in the world. She has always been there for me and I am hugely grateful to this amazing, brave, clever woman.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 72
// module chunks = 0